import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

import './not-found.css'

export default function NotFound() {
  return (
    <div className="not-found-container1">
      <Helmet>
        <title>404 - Not Found</title>
      </Helmet>
      <h3>OOPS! PAGE NOT FOUND</h3>
      <p style={{ marginTop: '1rem' }}>
        <Link to="/">Back to home</Link>
      </p>
      <div className="not-found-container2">
        <h1 className="not-found-text2">404</h1>
      </div>
      <div className="not-found-container3">
        <h2 className="not-found-text3">
          WE ARE SORRY, BUT THE PAGE YOU REQUESTED WAS NOT FOUND
        </h2>
      </div>
    </div>
  )
}
